import script from "./RoomNavbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoomNavbar.vue?vue&type=script&setup=true&lang=ts"

import "./RoomNavbar.vue?vue&type=style&index=0&id=d465e858&lang=scss&scoped=true"
import "./RoomNavbar.vue?vue&type=style&index=1&id=d465e858&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d465e858"]])

export default __exports__